export default __webpack_public_path__ + "static/media/fizzy.04adee1d.png";